export enum EntityType {
  Unknown = 0,
  AbEntry = 1,
  Opportunity = 2,
  Campaign = 3,
  User = 4,
  Case = 5,
  Appointment = 10,
  Task = 15,
  Lead = 19,
  InteractionLog = 20,
  InteractionLogDefault = InteractionLog,
  ImportTemplate = 17,
  Address = 63,
  Export = 69,
  SalesTeam = 1009,
  Interaction = 10003,
  EmailDocument = 10005,
  EmailDocumentDefault = EmailDocument,
  '@DataHubAccount' = 71,
  '@DataHubAccountPosition' = 71,
  '@DataHubAccountOwnership' = 71,
  '@DataHubInsurancePolicy' = 71,
  '@DataHubInsuranceCoverage' = 71,
  '@DataHubInsuranceClient' = 71,
  '@DataHubInsuranceBeneficiary' = 71,
  SearchCatalog = 54,
  Workflow = 72,
  WorkflowTaskTemplate = 73,
}

export type EntityCode = keyof typeof EntityType;

export const AppointmentEntityCode: EntityCode = 'Appointment';
export const AbEntryEntityCode: EntityCode = 'AbEntry';
export const CaseEntityCode: EntityCode = 'Case';
export const OpportunityEntityCode: EntityCode = 'Opportunity';
export const TaskEntityCode: EntityCode = 'Task';
export const AddressEntityCode: EntityCode = 'Address';
export const LeadEntityCode: EntityCode = 'Lead';
export const DataHubAccountEntityCode: EntityCode = '@DataHubAccount';
export const DataHubAccountPositionEntityCode: EntityCode =
  '@DataHubAccountPosition';
export const DataHubAccountOwnershipEntityCode: EntityCode =
  '@DataHubAccountOwnership';
export const DataHubInsurancePolicyEntityCode: EntityCode =
  '@DataHubInsurancePolicy';
export const DataHubInsuranceCoverageEntityCode: EntityCode =
  '@DataHubInsuranceCoverage';
export const DataHubInsuranceClientEntityCode: EntityCode =
  '@DataHubInsuranceClient';
export const DataHubInsuranceBeneficiaryEntityCode: EntityCode =
  '@DataHubInsuranceBeneficiary';
export const WorkflowEntityCode: EntityCode = 'Workflow';
export const WorkflowTaskTemplateEntityCode: EntityCode =
  'WorkflowTaskTemplate';
